import React from 'react';
import classNames from 'classnames';

import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import FunctionsIcon from '@material-ui/icons/Functions';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';

const queryIcons = {
    dataload: ViewColumnIcon,
    default: FunctionsIcon,
    datajoin: DeviceHubIcon
}

class PackageEditorQuery extends React.Component {
    
    state = {
        x: null,
        y: null
    }

    handleMouseDown = e => {
        if (e.altKey) {
            e.preventDefault();
            this.setState({ x: e.pageX, y: e.pageY });
            document.addEventListener('mousemove', this.handleMouseMove);
        }
    };

    handleMouseMove = e => {
        const { query: { id }, onMove } = this.props;
        const { x, y } = this.state;
        if (e.altKey) {
            e.preventDefault();
            this.setState({ x: e.pageX, y: e.pageY, move: true });
            onMove(id, e.pageX - x, e.pageY - y);
        }
    };

    handleMouseUp = e => {
        const { query, onClick } = this.props;
        const { move } = this.state;
        e.preventDefault();
        if (move !== true) {
            onClick(query);
        }
        this.setState({
            x: null,
            y: null,
            move: null
        });
        document.removeEventListener('mousemove', this.handleMouseMove);
    };

    getIcon = () => {
        const { query } = this.props;
        return queryIcons[query.icon];
    }

    render() {
        const { query, queryActionClass, selected } = this.props;
        const QueryIcon = this.getIcon();
        return (
                <g>
                    <rect x={query.x} y={query.y} fill={selected ? "#26A69A" : "white"} width="28px" height="28px" />
                    <QueryIcon x={query.x + 2} y={query.y + 2} style={{ color: selected ? "white" : "black" }} width="24px" height="24px" />
                    <rect className={classNames('query-object', queryActionClass === 'move' && 'move')} x={query.x} y={query.y}
                        onMouseOut={this.resetCursor} onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp}
                        stroke={selected ? "#26A69A" : "#000000"} strokeWidth="1" fill="transparent" width="28px" height="28px" />
                </g>
        )
    }
}
export default PackageEditorQuery;


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/PackageEditorQuery.js